import { Database, Tables } from "@punchup/data/supabase.types";

import { SupabaseClient } from "@supabase/supabase-js";
import { logException } from "@/analytics/sentry";

export type AdCampaign = Tables<"ad_campaigns">;
export type AdCampaignType = Tables<"ad_campaigns">["type"];

type Location = {
  latitude: number;
  longitude: number;
};

export async function getActiveAdCampaignsForLocation(
  supabase: SupabaseClient<Database>,
  campaignType: AdCampaignType,
  { latitude, longitude }: Location,
  rangeMiles: number
) {
  // retrieve ad campaigns near the specified location
  const { status, error, data } = await supabase.rpc(
    "ad_campaigns_near_location",
    {
      latitude,
      longitude,
      range_km: rangeMiles * 1.60934, // convert miles to km
      campaign_type: campaignType,
    }
  );

  if (error) {
    console.error(error);
    logException(error);
    return [];
  }

  if (status === 200 && data) {
    return data;
  }

  return [];
}
